// extracted by mini-css-extract-plugin
module.exports = {"root":"VisibilityDocumentContent_root__2J9gf","content":"VisibilityDocumentContent_content__3tMtK","active":"VisibilityDocumentContent_active__3xBt5"};